import React from 'react'
import CTA from '../../CTA';

function TestimonialSlide(props) {
    let backgroundColorClass =
    typeof props.backgroundColor != "undefined"
      ? "bg-" + props.backgroundColor.toLowerCase()
      : "";
      let bgImage;
      if(props.showImage){
        bgImage = {       
          backgroundImage: "url(" + `${props.image}` + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        };
      }
    
  const cardLink=props.CTAUrl;

  return (
      <>
        <div className={`testimonial-div`}>   
          <a tabIndex={0} {...cardLink?{href:cardLink}:{}}>        
            <div className={`testimonial-text-wrapper ${backgroundColorClass}`} style={ bgImage }>
                <h3 className='heading light'>{props.body}</h3>
                <p className="x-large-md small-sm x-small-xs italic author-name">{props.SpeakerName}</p>                
                <div className='testimonial-cta'>
                  <CTA text={props.CTAText} link={props.CTAUrl} sizeClass="bordered normal-md x-small-sm x-small-xs"/>
                </div>
            </div>      
          </a>      
        </div>
      </>
  )
}

export default TestimonialSlide